<template>
  <div
    class="editor"
  >
    <a-spin
      :spinning="imageLoading"
      tip="图片正在上传中"
    >
      <div
        class="wrap"
        @paste="handlePaste"
      >
        <quill-editor
          ref="myQuillEditor"
          v-model="value"
          :options="editorOption"
          :class="['edmEditor', {'quill-editor-fullscreen': isFullScreen}]"
          @focus="onEditorFocus($event)"
          @change="onEditorChange($event)"
        >
          <div
            :id="`toolbarEditEmail`"
            slot="toolbar"
          >
            <span
              v-if="toolbarItems.indexOf('font') !== -1"
              class="ql-formats"
            >
              <select
                title="字体"
                class="ql-font"
              >
                <option value="SimSun" />
                <option value="SimHei" />
                <option value="KaiTi" />
                <option value="LiSu" />
                <option value="youyuan" />
                <option value="MicrosoftYaHei" />
                <option value="Arial" />
                <option value="ArialBlack" />
                <option value="TimesNewRoman" />
                <option value="Verdana" />
              </select>
              <select
                v-if="toolbarItems.indexOf('size') !== -1"
                title="字号"
                class="ql-size"
              >
                <option
                  v-for="item in fontSizeStyle.whitelist"
                  :key="item"
                  :value="item"
                />
              </select>
            </span>
            <span class="ql-formats">
              <button
                v-if="toolbarItems.indexOf('bold') !== -1"
                title="加粗"
                class="ql-bold"
              />
              <button
                v-if="toolbarItems.indexOf('italic') !== -1"
                title="斜体"
                class="ql-italic"
              />
              <button
                v-if="toolbarItems.indexOf('underline') !== -1"
                title="下划线"
                class="ql-underline"
              />
              <button
                v-if="toolbarItems.indexOf('strike') !== -1"
                title="删除线"
                class="ql-strike"
              />
            </span>
            <span class="ql-formats">
              <button
                class="ql-script"
                value="sub"
              />
              <button
                class="ql-script"
                value="super"
              />
            </span>
            <span class="ql-formats">
              <select
                v-if="toolbarItems.indexOf('color') !== -1"
                title="字体颜色"
                class="ql-color"
              />
              <select
                v-if="toolbarItems.indexOf('background') !== -1"
                title="背景颜色"
                class="ql-background"
              />
            </span>
            <span
              v-if="toolbarItems.indexOf('list') !== -1"
              class="ql-formats"
            >
              <button
                title="有序列表"
                class="ql-list"
                value="ordered"
              />
              <button
                title="无序列表"
                class="ql-list"
                value="bullet"
              />
            </span>
            <span
              v-if="toolbarItems.indexOf('indent') !== -1"
              class="ql-formats"
            >
              <button
                title="增加缩进"
                class="ql-indent"
                value="-1"
              />
              <button
                title="减少缩进"
                class="ql-indent"
                value="+1"
              />
            </span>
            <span
              v-if="toolbarItems.indexOf('align') !== -1"
              class="ql-formats"
            >
              <select
                title="对齐方式"
                class="ql-align"
              />
            </span>
            <span class="ql-formats">
              <button
                v-if="toolbarItems.indexOf('link') !== -1"
                title="超链接"
                class="ql-link"
              />
              <button
                title="引用"
                class="ql-blockquote iconfont iconyinyong"
              />
              <button
                v-if="toolbarItems.indexOf('image') !== -1"
                title="图片"
                class="ql-image"
              />
            </span>
            <span
              v-if="toolbarItems.indexOf('clean') !== -1"
              class="ql-formats"
            >
              <button
                title="清除样式"
                class="ql-clean"
              />
            </span>
            <span
              v-if="toolbarItems.indexOf('fullscreen') !== -1"
              class="ql-formats"
            >
              <button
                :title="!isFullScreen ? '全屏' : '关闭全屏'"
                class="ql-fullscreen iconfont iconfull-screen"
                @click="customFullScreenClick"
              />
            </span>
            <span
              class="ql-formats"
            >
              <a-dropdown>
                <button
                  title="插入变量"
                  class="ql-insert-key iconfont"
                >
                  插入变量 <i class="iconfont iconxulie" />
                </button>
                <a-menu slot="overlay">
                  <a-menu-item>
                    <a @click="handleInsert('联系人')">
                      联系人
                    </a>
                  </a-menu-item>
                  <a-menu-item>
                    <a @click="handleInsert('邮箱')">
                      邮箱
                    </a>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </span>
            <span
              class="ql-formats fr"
            >
              <button
                title="html"
                class="ql-html"
                @click="customHtmlClick"
              >
                HTML编辑
                <i class="iconfont iconchange" />
              </button>
            </span>
          </div>
        </quill-editor>
        <a-upload
          ref="button"
          name="file"
          :headers="{ 'X-Requested-With': null }"
          :show-upload-list="false"
          :before-upload="beforeUpload"
          multiple
          accept="image/*"
          :action="action"
          :data="getOtherParams"
          class="hide"
          @change="uploadChangeHandle"
        />
      </div>
    </a-spin>
  </div>
</template>

<script>
import axios from 'axios'
import { upyunUpload, apiDomain } from '@/lib/config'
import { uploadSignature, uploadConvert } from '@/services/index'
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import * as Quill from 'quill' // 引入编辑器

// 重定义字体
let fonts = ['SimSun', 'SimHei', 'MicrosoftYaHei', 'KaiTi', 'FangSong', 'youyuan', 'LiSu', 'Arial', 'ArialBlack', 'TimesNewRoman', 'Verdana']
let Font = Quill.import('formats/font')
Font.whitelist = fonts // 将字体加入到白名单
Quill.register(Font, true)

// 重定义字号
let sizes = ['10px', '12px', '14px', '16px', '18px', '20px', '22px', '24px', '26px', '32px', '48px']
let fontSizeStyle = Quill.import('attributors/style/size')
fontSizeStyle.whitelist = sizes
Quill.register(fontSizeStyle, true)

export default {
  components: {
    quillEditor
  },
  inject: {
    myForm: {
      default: () => { }
    }
  },
  props: {
    content: {
      type: String,
      default: ''
    },
    toolbarItems: {
      type: Array,
      default: () => {
        return ['font', 'size', 'bold', 'italic', 'underline', 'strike', 'list', 'indent', 'color', 'background', 'align', 'link', 'image', 'clean', 'fullscreen']
      }
    },
    height: {
      type: Number,
      default: 460
    }
  },
  data () {
    let vm = this
    return {
      value: '',
      others: {},
      action: upyunUpload,
      pasteFiles: [],
      imageLoading: false,
      isFullScreen: false,
      savedRangeIndex: 0,
      fontSizeStyle,
      editorOption: {
        placeholder: '请输入文本',
        modules: {
          toolbar: {
            container: `#toolbarEditEmail`,
            handlers: {
              'image': function () {
                vm.$refs.button.$refs.uploadRef.$el.click()
              }
            }
          }
        }
      }
    }
  },
  computed: {
    editor () {
      return this.$refs.myQuillEditor && this.$refs.myQuillEditor.quill
    }
  },
  watch: {
    content: {
      handler (newValue, oldValue) {
        // this.value = newValue
        this.value = this.$filterXss.process(newValue)
      },
      immediate: true
    }
  },
  mounted () {
    // this.value = this.content
    this.value = this.$filterXss.process(this.content)

    this.$nextTick(() => {
      let $content = document.querySelector('.edmEditor.quill-editor .ql-container.ql-snow')
      let $tool = document.querySelector('.edmEditor.quill-editor .ql-toolbar.ql-snow')
      $content.style.height = this.$getPageSize().windowHeight - 180 - $tool.offsetHeight + 'px'
    })

    // 富文本失去焦点事件
    // this.$bus.$on('myQuillEditorBlur', this.onEditorBlur)
  },
  methods: {
    // 自定义富文本全屏
    customFullScreenClick () {
      this.isFullScreen = !this.isFullScreen
      let myQuillEditor = this.$refs.myQuillEditor
      let myQuillEditorEl = myQuillEditor.$el
      if (this.isFullScreen) {
        myQuillEditorEl.style.position = 'fixed'
        myQuillEditorEl.style.top = 0
        myQuillEditorEl.style.left = 0
        myQuillEditorEl.style.zIndex = 9999
        myQuillEditorEl.style.width = '100vw'
        myQuillEditorEl.style.height = '100vh'
        myQuillEditorEl.style.background = '#fff'
        document.body.style.overflow = 'hidden'
      } else {
        myQuillEditorEl.style.position = 'relative'
        myQuillEditorEl.style.zIndex = 1
        myQuillEditorEl.style.width = 'auto'
        myQuillEditorEl.style.height = 'auto'
        document.body.style.overflow = 'auto'
      }
    },
    customHtmlClick () {
      this.$emit('change', this.value)
      this.$emit('showHtml', true)
    },
    handleInsert (key) {
      const ins = this.$refs.myQuillEditor.quill
      let str = `{{${key}}}`
      let index = this.savedRangeIndex || (ins.getSelection() || {}).index || ins.getLength() - 1
      ins.insertText(index, str, {
        // 'color': '#ffff00',
        // 'italic': true
      })

      setTimeout(() => {
        ins.setSelection(index + str.length)
      }, 0)
    },
    /* onEditorBlur (quill) {
      setTimeout(() => {
        this.$emit('change', this.value)
      }, 500)
    }, */
    onEditorFocus (quill) {
      this.savedRangeIndex = quill.selection.savedRange.index
    },

    // 富文本内容更新
    onEditorChange ({ quill, html, text }) {
      this.value = html
      const ins = this.$refs.myQuillEditor.quill
      ins.setSelection(this.savedRangeIndex)
      this.$emit('change', this.value)
    },

    // 点击工具栏上传参数处理
    getOtherParams () {
      return this.others
    },

    // 点击工具栏上传
    beforeUpload (file) {
      const vm = this
      const { name: filename } = file
      const type = filename && filename.split('.')[1]

      if (file.type && file.type.indexOf('image') === -1) {
        this.$message.error('只能上传图片')
        return false
      }
      if (type === 'php') {
        this.$message.error('只能上传图片')
        return false
      }

      this.imageLoading = true

      return new Promise(async (resolve, reject) => {
        const chain = await uploadSignature()
        await chain
          .config({
            tip: false
          })
          .params({
            filename: [filename]
          })
          .onSuccess(async ([detail = {}]) => {
            const { policy, signature } = detail
            vm.others = {
              policy,
              signature
            }
            resolve(true)
          })
          .fetch()

        resolve(false)
      })
    },

    // 点击工具栏上传后又拍云的图片加密插入富文本
    async uploadChangeHandle (info) {
      const vm = this
      const { file } = info
      if (file.status === 'done') {
        const { response } = file
        const { url } = response
        if (url) {
          const chain2 = uploadConvert()
          await chain2
            .params({
              url
            })
            .onSuccess(payload => {
              const ins = vm.$refs.myQuillEditor.quill
              const index = (ins.getSelection() || {}).index || ins.getLength() - 1
              ins.insertEmbed(index, 'image', payload)
              setTimeout(() => {
                ins.setSelection(index + 1)
              }, 0)

              this.imageLoading = false
            })
            .fetch()
        }
      } else if (info.file.status === 'error') {
        console.log('error')
      }
    },
    // 复制事件
    handlePaste (event) {
      this.pasteFiles = []
      const items = (event.clipboardData || window.clipboardData).items

      let file = null

      if (!items || items.length === 0) {
        this.$message.error('当前浏览器不支持本地')
        return
      }
      // 搜索剪切板items
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf('image') !== -1) {
          event.preventDefault()

          this.imageLoading = true
          file = items[i].getAsFile()
          this.pasteFiles.push(file)
          this.pasteUpload(file)
        }
      }
    },

    // 复制图片/截图上传到又拍云
    pasteUpload (file) {
      if (!file) return
      let vm = this
      this.errorCount = 0
      this.successCount = 0
      if (file.size > 1024 * 1024 * 20) { // 支持20M以内的文件上传
        this.$message.error('不支持20M以上的文件上传')
        this.errorCount++
      }

      axios.post(`${apiDomain}/upload/signature`, {
        'filename': [file.name || 'pasteImg.jpg'] // 文件本地路径
      }).then(res => {
        vm.uploadFile(file, res.data.payload)
      })
    },
    /*  文件上传 */
    fileUpload (url, params, res = []) {
      axios.post(url || `http://v0.api.upyun.com/westartrack-file`, params, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(data => {
        if (data.data.code === 200) {
          let { _upt: upt = '' } = res && res[0]
          let url = ''
          if (upt.indexOf('?') !== -1) {
            url = upt.split('?')[0]
          } else {
            url = upt
          }
          this.insertPasteImg(url)

          this.successCount++
        } else {
          this.errorCount++
        }
        if (this.successCount + this.errorCount >= this.pasteFiles.length) {
          setTimeout(() => {
            if (this.errorCount) {
              this.$message.success('上传完成，' + this.errorCount + '个文件由于过大上传失败。')
            } else {
              this.$message.success('上传完成')
            }
          }, 100)
        }
      })
    },

    // 后端参数压缩上传
    async uploadFile (file, res) {
      let vm = this
      let url = res && res[0] && res[0].upyunurl

      // 构造FormData对象并赋值
      let formData = new FormData()
      formData.append('policy', res[0].policy) // 后端接口压缩图片参数
      formData.append('signature', res[0].signature)
      formData.append('file', file)
      vm.fileUpload(url, formData, res)
    },

    // 上传后的图片插入到富文本内
    async insertPasteImg (url) {
      let vm = this
      if (url) {
        const chain2 = uploadConvert()
        await chain2
          .params({
            url
          })
          .onSuccess(payload => {
            const ins = vm.$refs.myQuillEditor.quill
            const index = (ins.getSelection() || {}).index || ins.getLength() - 1
            ins.insertEmbed(index, 'image', payload)
            setTimeout(() => {
              ins.setSelection(index + 1)
            }, 0)

            this.imageLoading = false
          })
          .fetch()

        this.imageLoading = false
      }
    }
  }
}
</script>
<style lang="scss">
@import '~@/assets/fonts/youyuan/youyuan.css';
@import '~@/assets/fonts/LiSu/LiSu.css';
.edmEditor.quill-editor {
  a,
  abbr,
  acronym,
  address,
  applet,
  article,
  aside,
  audio,
  b,
  big,
  blockquote,
  body,
  canvas,
  caption,
  center,
  cite,
  code,
  dd,
  del,
  details,
  dfn,
  div,
  dl,
  dt,
  em,
  embed,
  fieldset,
  figcaption,
  figure,
  footer,
  form,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  header,
  html,
  i,
  iframe,
  img,
  input,
  ins,
  kbd,
  label,
  legend,
  li,
  mark,
  menu,
  nav,
  object,
  ol,
  output,
  p,
  pre,
  q,
  ruby,
  s,
  samp,
  section,
  small,
  span,
  strike,
  strong,
  sub,
  summary,
  sup,
  table,
  tbody,
  td,
  tfoot,
  th,
  thead,
  time,
  tr,
  tt,
  u,
  ul,
  var,
  video {
    font-weight: inherit;
  }
  strong {
    font-weight: bold;
  }
  .ant-form-explain {
    line-height: 40px;
  }
  .ql-toolbar.ql-snow {
    padding: 12px 25px 0;
    line-height: 1;
    border: 0;
    border-bottom: solid 1px #ebebeb;
    .ql-formats {
      margin-bottom: 12px;
      &:last-child {
        margin-right: 0;
      }
      .ql-fullscreen {
        outline: none;
      }
    }
    .ql-font, .ql-size {
      .ql-picker-options {
        overflow: scroll;
        max-height: 300px;
      }
    }
    button.ql-insert-key, .ql-font.ql-picker, .ql-size.ql-picker {
      height: 32px;
      border-radius: 2px;
      border: 1px solid #EBEBEB;
      .ql-picker-label {
        line-height: 28px;
      }
      > svg .ql-stroke {
        stroke: #D8D8D8;
      }
    }
    .ql-blockquote svg {
      display: none;
    }
    .ql-html {
      float: right;
      width:104px;
      height:32px;
      font-size: 14px;
      font-family: PingFangSC-Regular,PingFang SC;
      font-weight: 400;
      color:rgba(0,0,0,1);
      line-height: 20px;
      background:rgba(255,255,255,1);
      border-radius: 2px;
      border: 1px solid rgba(235,235,235,1);
      .iconfont {
        color: #D8D8D8;
      }
    }
  }

  .ql-container.ql-snow {
    height: 300px;
    margin-bottom: 8px;
    border: 0;
  }

  .ql-editor.ql-blank::before {
    color: #bfbfbf;
    font-style: normal;
  }
  .ql-snow .ql-tooltip {
    z-index: 99;
  }
  .ql-snow .ql-tooltip[data-mode='link']::before {
    content: '请输入链接地址:';
  }
  .ql-snow .ql-tooltip.ql-editing a.ql-action::after {
    border-right: 0px;
    content: '保存';
    padding-right: 0px;
  }
  .ql-tooltip.ql-editing {
    transform: translateY(-20px);
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value='SimSun']::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value='SimSun']::before {
    content: '宋体';
    font-family: 'STSong', 'SimSun';
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value='SimHei']::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value='SimHei']::before {
    content: '黑体';
    font-family: 'STHeiti', 'SimHei';
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value='KaiTi']::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value='KaiTi']::before {
    content: '楷体';
    font-family: 'STKaiti', 'KaiTi';
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value='FangSong']::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value='FangSong']::before {
    content: '仿宋';
    font-family: 'STFangsong', 'FangSong';
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value='LiSu']::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value='LiSu']::before {
    content: '隶书';
    font-family: '隶书', 'LiSu', 'STLiti', 'MingLiu', 'LiShu';
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value='youyuan']::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value='youyuan']::before {
    content: '幼圆';
    font-family: 'youyuan';
  }
  .ql-snow
    .ql-picker.ql-font
    .ql-picker-label[data-value='MicrosoftYaHei']::before,
  .ql-snow
    .ql-picker.ql-font
    .ql-picker-item[data-value='MicrosoftYaHei']::before {
    content: '微软雅黑';
    font-family: "Microsoft YaHei", '微软雅黑';
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value='Arial']::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value='Arial']::before {
    content: 'Arial';
    font-family: 'Arial';
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value='ArialBlack']::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value='ArialBlack']::before {
    content: 'Arial Black';
    font-family: 'Arial Black';
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value='TimesNewRoman']::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value='TimesNewRoman']::before {
    content: 'Times New Roman';
    font-family: 'Times New Roman';
    font-size: 12px;
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value='Verdana']::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value='Verdana']::before {
    content: 'Verdana';
    font-family: 'Verdana';
  }

  .ql-font-SimSun {
    font-family: 'STSong', 'SimSun';
  }
  .ql-font-SimHei {
    font-family: 'STHeiti', 'SimHei';
  }
  .ql-font-MicrosoftYaHei {
    font-family: "Microsoft YaHei", '微软雅黑';
  }
  .ql-font-KaiTi {
    font-family: 'STKaiti', 'KaiTi';
  }
  .ql-font-FangSong {
    font-family: 'STFangsong', 'FangSong';
  }
  .ql-font-LiSu {
    font-family: '隶书', 'LiSu', 'STLiti', 'MingLiu', 'LiShu';
  }
  .ql-font-youyuan {
    font-family: 'YouYuan', 'youyuan';
  }
  .ql-font-Arial {
    font-family: 'Arial';
  }
  .ql-font-ArialBlack {
    font-family: 'Arial Black';
  }
  .ql-font-TimesNewRoman {
    font-family: 'Times New Roman';
  }
  .ql-font-Verdana {
    font-family: 'Verdana';
  }

  .quill-editor-fullscreen .ql-container.ql-snow {
    height: calc(100% - 42px);
  }
  .ql-insert-key {
    width: 98px;
    font-size:14px;
    .iconfont {
      font-size: 12px;
    }
  }
  .ql-font {
    margin-right: 8px;
  }

  @for $i from 10 through 50 {
    // .item-#{$i}
    @if $i % 2 == 0 {
      .ql-snow .ql-picker.ql-size .ql-picker-item[data-value='#{$i}px']::before {
        // width:(20px * $i);
        content: "#{$i}px";
        font-size: $i + px;
      }
      .ql-font-#{$i}px {
        font-size: $i + px;
      }
    }
  }
}
</style>
